import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PeriodService {

  private openCashRegister = new BehaviorSubject(null);
  openCashRegister$ = this.openCashRegister.asObservable();


  constructor(private http: HttpClient) { }

  get getOpenCashRegister(){
    return this.openCashRegister.value;
  }

  setOpenCashRegister(openCashRegister){
    this.openCashRegister.next(openCashRegister);
  }

  getCashPeriodsByCashier(posCashierId,status){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/pos-cashier-periods/pos-cashiers/${posCashierId}?state=${status}&sort=id,DESC`, httpOptions);
  }

  getCashPeriodsById(cashPeriodId){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/pos-cashier-periods/${cashPeriodId}`, httpOptions);
  }

  getAllCashPeriods(){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/pos-cashier-periods?sort=id,DESC`, httpOptions);
  }

  getCashPeriodsFilters(filter){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/pos-cashier-periods${filter}&sort=id,DESC`, httpOptions);
  }

  getCashPeriodsByStatus(status){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/pos-cashier-periods?state=${status}&sort=id,DESC`, httpOptions);
  }

  openCashPeriods(cashRegister) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.post<any>(`${environment.url_api}/pos-cashier-periods/pos-cashier-movements`,cashRegister, httpOptions);
  }

  openCashPeriodsAndMovements(cashRegister) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.post<any>(`${environment.url_api}/pos-cashier-periods/pos-cashier-movements`,cashRegister, httpOptions);
  }

  closeCashPeriods(cashPeriodId:number) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.patch<any>(`${environment.url_api}/pos-cashier-periods/${cashPeriodId}/close-period`,{}, httpOptions);
  }

  getCashPeriodsMovements(cashPeriodId){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.get<any>(`${environment.url_api}/pos-cashier-movements/pos-cashier-periods/${cashPeriodId}`, httpOptions);
  }

  createCashPeriodsMovements(movements) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('ACCESS_TOKEN'),
      })
    };
    return this.http.post<any>(`${environment.url_api}/pos-cashier-movements`,movements, httpOptions);
  }
}
